import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { DatePicker,TimePicker } from 'antd'; // Assuming you're using Ant Design for TimePicker

const TimeSheetRequestModal = ({ open,setOpen }) => {
    const [formData, setFormData] = useState({
        workFrom: '',
        inTime: null,
        outTime: null,
        reason: '',
        regularizeDate: null,
    });
    const [errors, setErrors] = useState({});
    const [savebtn, setSaveBtn] = useState(true);

    // Handle changes in form fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleTimeChange = (time, field) => {
        setFormData((prevData) => ({
            ...prevData,
            [field]: time,
        }));
    };

    const handleDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            regularizeDate: date,
        }));
    };
    
    // Validate form data
    const validateForm = () => {
        const validationErrors = {};
        let isValid = true;

        // Regularize Date validation
        if (!formData.regularizeDate) {
            validationErrors.regularizeDate = 'Regularize date is required';
            isValid = false;
        }

        // In-time validation
        if (!formData.inTime) {
            validationErrors.inTime = 'In Time is required';
            isValid = false;
        }

        // Out-time validation
        if (!formData.outTime) {
            validationErrors.outTime = 'Out Time is required';
            isValid = false;
        } else if (formData.outTime <= formData.inTime) {
            validationErrors.outTime = 'Out Time should be after In Time';
            isValid = false;
        }

        // Reason validation
        if (!formData.reason) {
            validationErrors.reason = 'Reason is required';
            isValid = false;
        }

        setErrors(validationErrors);
        return isValid;
    };
    const handleCloseModel = () =>{
        setOpen(false)
    }
    // Handle form submission
    const handleSubmit = () => {
        if (validateForm()) {
            // Proceed with form submission (e.g., send data to an API)
            console.log('Form submitted successfully', formData);
            handleCloseModel(); // Close modal after submission
        }
    };

    return (
        <Modal show={open} size="md" id="confirm_login">
            <div className="modal-body">
                <button
                    type="button"
                    onClick={handleCloseModel}
                    className="float-end btn_close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                    <i className="icon icon-cross"></i>
                </button>
                <div className="dash_white_box_ttl text-center" id="exampleModalLabel">
                    Time Sheet Request
                </div>
                <form>
                    <div className="mb-2">
                        <label className="col-form-label">Select Type :</label>
                        <select
                            value={1}
                            className="form-select"
                            id="leavetype"
                            
                        >
                            <option selected value="2">
                                Regularise Time Sheet
                            </option>
                        </select>
                    </div>

                    <div className="timesheet_select">
                        <div className="mb-2">
                            <label className="col-form-label">
                                Regularize Date : <sup className="error_mgs"> *</sup>
                            </label>
                            <DatePicker
                                selected={formData.regularizeDate}
                                onChange={handleDateChange}
                                disabledDate={(d) => !d || d.isAfter(new Date(Date.now() - 3600 * 1000 * 24))}
                                className="form-control"
                                use12Hours
                            />
                            {errors.regularizeDate && <p className="error">{errors.regularizeDate}</p>}
                        </div>

                        <div className="mb-2">
                            <label className="col-form-label">Work From :</label>
                            <select
                                className="form-select"
                                name="workFrom"
                                value={formData.workFrom}
                                onChange={handleChange}
                            >
                                <option value="">Select Work From</option>
                                <option value="1">Work From Office</option>
                                <option value="2">Work From Home</option>
                            </select>
                        </div>
                        <div className="mb-2 row">
                            <div className="col-md-6">
                                <label className="col-form-label">In Time :</label>
                                <TimePicker
                                    className="form-control"
                                    use12Hours
                                    format="h:mm A"
                                    value={formData.inTime}
                                    onChange={(time) => handleTimeChange(time, 'inTime')}
                                    showNow={false}
                                />
                                {errors.inTime && <p className="error">{errors.inTime}</p>}
                            </div>
                            <div className="col-md-6">
                                <label className="col-form-label">Out Time : </label>
                                <TimePicker
                                    className="form-control"
                                    use12Hours
                                    format="h:mm A"
                                    value={formData.outTime}
                                    onChange={(time) => handleTimeChange(time, 'outTime')}
                                    showNow={false}
                                />
                                {errors.outTime && <p className="error">{errors.outTime}</p>}
                            </div>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="col-form-label">Reason</label>
                        <textarea
                            className="form-control"
                            name="reason"
                            value={formData.reason}
                            onChange={handleChange}
                        />
                        {errors.reason && <p className="error">{errors.reason}</p>}
                    </div>
                </form>
                <div className="modalfooter">
                    <button
                        type="button"
                        className="btn_6 float-end ml10"
                        onClick={handleCloseModel}
                        data-bs-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button
                        style={{ display: savebtn ? 'block' : 'none' }}
                        type="button"
                        className="btn_5 float-end"
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                    <span className="float-end mt10 mr08"></span>
                </div>
            </div>
        </Modal>
    );
};

export default TimeSheetRequestModal;
